<template>
  <van-popup v-model:show="data.show" round>
    <div class="container">
      <div class="pay_popup">
        <p>{{ $t('reader.purchase_successful') }}</p>
        <div class="coins">
          <div class="icon_box">
            <img src="~/assets/images/me/icon-me-coin.svg" alt="">
            <p>{{ data.extraData?.order?.coin }}</p>
          </div>
          <p>+{{ data.extraData?.order.gift_coin }} {{ $t('reader.coins') }}</p>
        </div>
        <div class="got_it_btn" @click="closePopup">{{ $t('reader.i_got_it') }}</div>
        <img class="icon_w" src="~/assets/images/reader/icon-reader-coins.png" alt="">
        <img class="icon_l" src="~/assets/images/reader/icon-reader-light.png" alt="">
        <img class="icon_c" src="~/assets/images/reader/icon-reader-popup-close.png" alt="" @click="closePopup">
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import {reactive} from 'vue'
import {useUserInfo} from '~/composables/useUserInfo'
import eventBus from "../../utils/eventBus";
import {useCommonStore} from '../../stores/common'
const {getUserInfo} = useUserInfo()
const commonStore = useCommonStore()
const route = useRoute()
const data = reactive({
  show: false,
  extraData: {}
})

const closePopup = async() => {
  data.show = false
  // 判断下有没有绑定邮箱
  await commonStore.getBindEmail()
  console.log('绑定邮箱', commonStore.email)
  // 如果没有绑定邮箱，则不去触发updateChapterList方法，而是在邮箱绑定弹窗中去操作
  if (commonStore.email === ''){
    eventBus.emit('showBindEmailPopup')
  } else {
    eventBus.emit('updateChapterList', route.query.chapter_id ? route.query.chapter_id : '')
  }
}

const open = async (extraData) => {
  console.log('金币购买成功弹窗:', extraData)
  //   获取到同一订单的order_no
  const orderNo = localStorage.getItem('order_no')
  if (!orderNo) {
    // 如果没有，说明从来没弹过，直接弹出弹窗
    data.show = true
    data.extraData = extraData
  } else {
    if (orderNo === route.query.order_no) return false
    data.show = true
    data.extraData = extraData
  }
  localStorage.setItem('order_no', route.query.order_no)
  //   弹出这个弹窗说明金币购买成功，调一下用户详情接口更新一下钱包余额
  await getUserInfo()
}

defineExpose({
  open,
  closePopup
})

</script>

<style scoped lang="scss">
.van-popup {
  background: transparent;

}

.container {
  position: relative;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;

  .pay_popup {
    width: 302px;
    background: #FF1979;
    background: url('~/assets/images/reader/icon-reader-pay-success.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    padding: 50px 21px 21px;
    position: relative;
    border-radius: 21px;

    p {
      font-weight: 600;
      font-size: 19px;
      color: #222222;
      line-height: 22px;
      text-align: center;
      font-style: normal;
    }

    .icon_w {
      position: absolute;
      left: 50%;
      top: -60px;
      width: 156px;
      transform: translateX(-50%);
    }

    .icon_l {
      position: absolute;
      left: 50%;
      top: -98px;
      width: 281px;
      transform: translateX(-50%);
      z-index: -1;
    }

    .icon_c {
      position: absolute;
      left: 50%;
      top: calc(100% + 21px);
      width: 25px;
      transform: translateX(-50%);
      height: 25px;
    }

    .coins {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-top: 10px;

      .icon_box {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;

        p {
          font-family: D-DIN-PRO, D-DIN-PRO;
          font-weight: bold;
          font-size: 33px;
          color: #FF1979;
          line-height: 40px;
          text-align: right;
          font-style: normal;
        }

        img {
          width: 26px;
          height: 26px;
        }
      }

      > p {
        font-family: 'SFPro', 'SFPro';
        font-weight: 500;
        font-size: 19px;
        color: #32343A;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        margin-top: 6px;
      }
    }

    .got_it_btn {
      width: 100%;
      height: 47px;
      background: linear-gradient(90deg, #FF394D 0%, #FF398F 100%);
      box-shadow: 0px 2 10px 0px rgba(232, 57, 102, 0.3), inset 0px 3 8px 0px rgba(255, 190, 217, 0.8);
      border-radius: 23px;
      font-family: 'SFPro', 'SFPro';
      font-weight: 600;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 47px;
      text-align: center;
      font-style: normal;
      margin-top: 26px;
    }
  }
}

</style>
